import data from './Surfing.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function Surfing() {

  return WithPage(data, "surf")

}
